/*=====================================
    GameHomeView

    Author: Ac
    CreateTime: 2018 / 10 / 03
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import styled from 'styled-components';
import GameList from 'components/game/GameList';
import GameHomeSideBar from 'components/game/GameHomeSideBar';

/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    position: relative;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
`;
const ListWrapper = styled.div`
    width: 100%;
`;

/*--------------------------
    Main Component
--------------------------*/
class GameHomeView extends Component {

    render() {
        return (
            <Container>
                <ListWrapper>
                    <GameList />
                </ListWrapper>
                <GameHomeSideBar />
            </Container>
        );
    }
}

/*--------------------------
    Export
--------------------------*/
export default GameHomeView;